module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//1_normal.png?v=a9c5a69d";